import React, { Suspense } from 'react';
import { ApolloProvider } from '@apollo/client';
import client from 'services/apollo-client';
import 'i18n';
import Routes from 'routes';
import ErrorBoundary from 'components/error-boundary';
import SessionProvider from 'components/providers/session-provider';
import styled, { ThemeProvider } from 'styled-components';
import { color, typography } from 'styles/settings';

export const theme = { ...color.theme, name: 'cortlex', logo: '' };
export const themeCX = theme;

function App() {
  return (
    <ApolloProvider client={client}>
      <ErrorBoundary>
        <SessionProvider>
          <Suspense fallback={<NullComponent />}>
            <ThemeProvider theme={theme}>
              <Routes />
            </ThemeProvider>
          </Suspense>
        </SessionProvider>
      </ErrorBoundary>
    </ApolloProvider>
  );
}

function NullComponent() {
  return null;
}

export default App;
